import { FiMenu, FiHome } from "react-icons/fi";
import { FaShip, FaStar, FaUtensils } from "react-icons/fa";
import { GiSailboat, GiWaveSurfer } from "react-icons/gi";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import { Link } from "react-router-dom";

const MobileMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* Hamburger Button */}
      {!menuOpen && (
        <button
          onClick={() => setMenuOpen(true)}
          className="md:hidden text-2xl p-2 focus:outline-none relative z-50 text-gray-800 dark:text-white"
          aria-label="Open Menu"
        >
          <FiMenu />
        </button>
      )}

      {/* Animated Fullscreen Menu from Left */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "spring", stiffness: 120, damping: 20 }}
            className="fixed top-0 left-0 w-full h-screen z-40 bg-white dark:bg-gray-900 shadow-xl px-6 pt-20 overflow-y-auto"
          >
            {/* Close button */}
            <motion.button
              onClick={() => setMenuOpen(false)}
              className="absolute top-6 right-6 text-gray-800 dark:text-white text-3xl focus:outline-none cursor-pointer"
              aria-label="Close Menu"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              &times;
            </motion.button>

            <div className="flex flex-col gap-6">
              {/* Home */}
              <MenuItem
                icon={<FiHome />}
                label="Home"
                to="/"
                setMenuOpen={setMenuOpen}
                delay={0.05}
              />

              {/* Boat Tours */}
              <MenuItem
                icon={<FaShip />}
                label="Boat Tours"
                to="/boat-tours"
                setMenuOpen={setMenuOpen}
                delay={0.1}
              />

              {/* Unique Tours */}
              <MenuItem
                icon={<FaStar />}
                label="Unique Tours"
                to="/unique-tours"
                setMenuOpen={setMenuOpen}
                delay={0.13}
              />

              {/* Luxury Yacht */}
              <MenuItem
                icon={<GiSailboat />}
                label="Luxury Yacht"
                to="/luxury-yacht"
                setMenuOpen={setMenuOpen}
                delay={0.16}
              />

              {/* Jet Ski's */}
              <MenuItem
                icon={<GiWaveSurfer />}
                label="Jet Ski's"
                to="/jet-ski"
                setMenuOpen={setMenuOpen}
                delay={0.19}
              />

              {/* Add Extras */}
              <MenuItem
                icon={<FaUtensils />}
                label="Add Extras"
                to="/add-extras"
                setMenuOpen={setMenuOpen}
                delay={0.22}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const MenuItem = ({ icon, label, to, setMenuOpen, delay }) => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: 20 }}
    transition={{ delay }}
  >
    <Link
      to={to}
      onClick={() => setMenuOpen(false)}
      className="flex items-center gap-3 text-xl font-medium text-gray-800 dark:text-white hover:text-yellow-400 transition relative group"
    >
      {icon}
      <span>{label}</span>
      <span className="absolute bottom-[-2px] left-0 h-[2px] w-0 bg-yellow-400 group-hover:w-full transition-all duration-300" />
    </Link>
  </motion.div>
);

export default MobileMenu;
